import React from 'react';
import PropTypes from 'prop-types';

const TaxFlowChartSectionFive = (props) => {
  const offset = props.partnerInsurance ? 'col-sm-offset-1' : 'col-sm-offset-7';
  const title = props.partnerInsurance ? 'You will retain your health insurance through your partner' : 'You should consider the cost of healthcare in your state';
  const imageSrc = props.partnerInsurance ? 'healthcare-partner-2x.png' : 'healthcare-single-2x.png';
  return (
    <React.Fragment>
      <div className="row tax-flow-chart-section-five">
        <div className={`col-sm-4 ${offset}`}>
          <p>{title}</p>
        </div>
      </div>
      {props.section === 4 &&
        <div className="row">
          <div className={`col-sm-4 ${offset}`}>
            <img src={`${props.cdnURL}/images/TaxFlowChart/${imageSrc}`} alt="Healthcare" />
          </div>
        </div>
      }
    </React.Fragment>
  );
};

TaxFlowChartSectionFive.propTypes = {
  section: PropTypes.number.isRequired,
  partnerInsurance: PropTypes.bool.isRequired,
  cdnURL: PropTypes.string.isRequired,
};

export default TaxFlowChartSectionFive;



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/components/TaxFlowChartSectionFive.jsx